import type { WidgetModule } from "../dashboard-app/types"

const widgetModule: WidgetModule = {
  widgets: []
}

export default widgetModule